<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end">
                <ion-button class="pill next-pill-button" @click="skip">
                    Skip
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <PageTitle title="Select Gender" subtitle="Please select your gender for Super and AHPRA verifications!"
                    showIcon />

                <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                    @submit.prevent="goNext('userForm')">
                    <div class="buttons_wrapper">
                        <el-button :class="{ active: formsData.userForm.gender.value === 1 }" type="transparent"
                            @click="selectGender(1)">

                            Male
                            <span v-if="formsData.userForm.gender.value === 1" class="checkmark"><svg width="20"
                                    height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                        fill="white" />
                                </svg>
                            </span>
                        </el-button>
                        <el-button :class="{ active: formsData.userForm.gender.value === 2 }" type="transparent"
                            @click="selectGender(2)">
                            Female
                            <span v-if="formsData.userForm.gender.value === 2" class="checkmark"><svg width="20"
                                    height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                        fill="white" />
                                </svg>
                            </span>
                        </el-button>
                        <el-button :class="{ active: formsData.userForm.gender.value === 3 }" type="transparent"
                            @click="selectGender(3)">
                            Other
                            <span v-if="formsData.userForm.gender.value === 3" class="checkmark"><svg width="20"
                                    height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                        fill="white" />
                                </svg>
                            </span>
                        </el-button>
                        <el-button class="submit" type="blue" @click="goNext('userForm')"
                            :disabled="formsData.userForm.disabled || formsData.userForm.gender.value === null">Continue</el-button>
                    </div>
                </el-form>

            </div>
        </div>
        <div class="background-circles">
            <div class="circle circle-2"></div>
            <div class="circle circle-1"></div>
            <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
        </div>
    </div>
</template>

<script>
import './Gender.scss';
import { onMounted, inject, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import PageTitle from '@/components/PageTitle/PageTitle.vue';

import { useStore } from "vuex";

import { useRoute, useRouter } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { ElMessageBox } from 'element-plus';
const gender = ref(null);

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
        SvgIcon
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const userData = $store.getters.GET_USER_DATA;

        const formsDataArray = {
            userForm: {
                ref: gender,
                gender: {
                    value: userData.gender || null,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "gender",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };

        const goBack = async () => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    $router.push({
                        name: "auth_ahpra",
                    });
                } catch (error) {
                    console.log(error);
                }
            })();
        };

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            console.log(getFormValues(formName))
                            await $store.dispatch("SAVE_USER_DATA", getFormValues(formName));
                            $router.push({
                                name: "auth_ahpra",
                            });
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            setFormRefs();
            checkFormValidation("userForm", false);
        });

        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);


        const selectGender = (selectedGender) => {
            formsData.userForm.gender.value = selectedGender;
        }

        return {
            formsData,
            goBack,
            goNext,
            selectGender,
            skip
        };
    },
};
</script>
